<template>
  <div class="legend">
    <div v-for="(item, index) in data" :key="item[0]" class="legend-row">
      <span
        class="column color"
        :style="{'background-color': getColor(item[0], index) + ' !important'}"
        v-if="typeof(item[1]) != 'object'"
      ></span>
      <span class="column" :style="{'text-align': titleAlign}">{{ item[0] }}</span>
      <span class="column total">{{ totalDisplay(item) }}</span>
    </div>
  </div>
</template>

<script>
import chartMixin from './mixins/chartMixin';

export default {
  props: {
    titleAlign: {
      type: String,
      default: 'center',
    },
    isPercentage: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [chartMixin],
  computed: {
    totalDisplay() {
      return item => {
        const total = item[1].toLocaleString();
        if (this.isPercentage) {
          return `${total}%`;
        }
        return total;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.legend {
  display: table;
  width: 100%;
  padding: 12px 0;
}
.legend-row {
  display: table-row;
}
.column {
  display: table-cell;
}
.color {
  display: inline-block;
  width: 10px;
  height: 10px;
}
.total {
  text-align: right;
}
.total2 {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// ChartLegend.vue?42a8cd5c